/** Tapered willow creels. All open mouths share one horizontal row, never a face pattern. */
import { checkEnvelope, checkScope, el, n, partGroup } from '../../svg';
import type { PieceArt, PieceOpening, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, grainRng, ground, line } from './machinerySvg';
export interface EelTrapsParams { readonly traps: number; readonly wet: number }
export type EelTrapsRecipe = PieceRecipe<'mill.eel_traps.v1', EelTrapsParams>;
export const EEL_TRAPS_FRAME = { w: 110, h: 80 } as const;
export const MILL_EEL_TRAPS: EelTrapsRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.eel_traps.default.v1', generatorId: 'mill.eel_traps.v1',
  seed: 20071010, paletteId: 'millrace_amber', params: { traps: 3, wet: 0.8 },
};
export function buildEelTraps(recipe: EelTrapsRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_EEL_TRAPS.generatorId); checkScope(scope);
  const traps = amount(recipe.params.traps, 'traps', 2, 4, true), wet = amount(recipe.params.wet, 'wet');
  const random = grainRng(recipe), parts: string[] = [], openings: PieceOpening[] = [];
  let wicker = '';
  for (let i = 0; i < traps; i++) {
    const x = 16 + i * 78 / (traps - 1), top = 11 + random(`height.${i}`) * 8;
    wicker += el('path', { d: `M${n(x - 7)} ${n(top)}Q${n(x - 14)} 33 ${n(x - 11)} 64Q${n(x)} 73 ${n(x + 11)} 64Q${n(x + 14)} 33 ${n(x + 7)} ${n(top)}Z`, fill: p.reedShadow, stroke: p.outline, 'stroke-width': 1.2 });
    for (let j = -3; j <= 3; j++) wicker += el('path', { d: `M${n(x + j * 1.8)} ${n(top + 2)}Q${n(x + j * 3.9)} 36 ${n(x + j * 3)} 64`, fill: 'none', stroke: p.woodLight, 'stroke-width': 1.2 });
    for (let j = 0; j < 7; j++) wicker += el('path', { d: `M${n(x - 10)} ${27 + j * 5}Q${n(x)} ${31 + j * 5} ${n(x + 10)} ${27 + j * 5}`, fill: 'none', stroke: p.woodBase, 'stroke-width': 1.3 });
    wicker += el('ellipse', { cx: x, cy: 63, rx: 11, ry: 7, fill: p.woodLight, stroke: p.outline, 'stroke-width': 1 })
      + el('ellipse', { cx: x, cy: 63, rx: 8, ry: 4.5, fill: p.outline })
      + el('path', { d: `M${n(x - 7)} 63Q${n(x)} 68 ${n(x + 7)} 63`, fill: 'none', stroke: p.reedBase, 'stroke-width': 0.8 })
      + line(x - 3, top + 2, x + 3, top + 2, p.woodBase, 2)
      + line(x - 7, 39, x - 7, 51, p.waterLight, wet * 1.4);
    openings.push({ x: x - 8, y: 58.5, width: 16, height: 9, fill: p.outline });
  }
  const body = partGroup(parts, 'trap-ground', ground(110, 80, p)) + partGroup(parts, 'willow-eel-creels', wicker);
  return { frame: EEL_TRAPS_FRAME, body, anchors: { support: { x: 55, y: 80 } }, parts, openings };
}
